/**
 * 顶部右侧 设置 / 用户 dropdown 菜单。
 */

import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

export function SettingsMenu() {
  const { tenant, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <a
        onClick={() => setOpen(!open)}
        style={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 8,
          background: open ? 'var(--surface-hover)' : 'transparent',
        }}
      >
        <div style={{
          width: 30, height: 30, borderRadius: '50%',
          background: 'var(--accent)',
          color: 'white',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 600, fontSize: 13,
        }}>
          {tenant?.company_name?.[0] || '?'}
        </div>
        <span style={{ fontSize: 14, color: 'var(--text)' }}>
          {tenant?.company_name || '未登录'}
        </span>
        <span style={{ color: 'var(--text-dim)', fontSize: 11 }}>▾</span>
      </a>

      {open && (
        <div className="menu" onClick={() => setOpen(false)}>
          <div className="menu-label">{tenant?.phone}</div>
          <div className="menu-divider" />
          <div className="menu-label">设置</div>
          <Link to="/admin/settings/interviewers">面试官</Link>
          <Link to="/admin/settings/account">公司信息</Link>
          <div className="menu-divider" />
          <button onClick={(e) => { e.stopPropagation(); logout(); }} style={{ color: 'var(--danger)' }}>
            退出登录
          </button>
        </div>
      )}
    </div>
  );
}
